import * as React from "react";

const SvgWechat = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 12 12"
    fill="currentColor"
    {...props}
  >
    <path
      id="wechat_svg__a"
      d="M10.751 8.764C11.513 8.211 12 7.395 12 6.487c0-1.663-1.618-3.012-3.614-3.012-1.996 0-3.615 1.349-3.615 3.012S6.39 9.499 8.386 9.499c.412 0 .81-.059 1.18-.165l.105-.016c.07 0 .133.021.193.056l.791.457.07.022a.12.12 0 00.12-.12l-.02-.088-.162-.608-.013-.077a.24.24 0 01.101-.196zM4.338.15C1.942.15 0 1.768 0 3.765c0 1.089.584 2.069 1.498 2.732a.285.285 0 01.122.235l-.015.092-.196.729-.023.106c0 .08.065.144.145.144l.084-.026.949-.549a.455.455 0 01.23-.066l.127.019c.444.127.921.198 1.417.198l.237-.006a2.793 2.793 0 01-.145-.886c0-1.82 1.771-3.296 3.956-3.296l.235.006C8.294 1.47 6.501.15 4.337.15zM7.18 6.005a.481.481 0 11-.001-.963.481.481 0 01.001.963zm2.41 0a.48.48 0 11-.002-.962.48.48 0 01.002.962zm-6.7-2.819a.578.578 0 110-1.157.578.578 0 010 1.157zm2.892 0a.578.578 0 110-1.155.578.578 0 010 1.155z"
    />
  </svg>
);

export default SvgWechat;
